import React from 'react';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import loc from 'owa-localize';
import {
    safeModeLabel,
    recoveryModeLabel,
    configJsonActiveLabel,
    configJsonActiveDetails,
} from './getExtraTopRibbonControlsAfterTabs.locstring.json';
import { modeContainer, configJsonIndicator } from './getExtraTopRibbonControlsAfterTabs.scss';

export const SafeMode: React.FC = () => (
    <div className={modeContainer}>
        <label>{loc(safeModeLabel)}</label>
    </div>
);

export const RecoveryMode: React.FC = () => (
    <div className={modeContainer}>
        <label>{loc(recoveryModeLabel)}</label>
    </div>
);

export const ConfigJsonActive: React.FC = () => (
    <div className={modeContainer}>
        <TooltipHost content={loc(configJsonActiveDetails)}>
            <span className={configJsonIndicator}>{loc(configJsonActiveLabel)}</span>
        </TooltipHost>
    </div>
);
